import styled from 'styled-components'
import { LockAlt } from '@styled-icons/boxicons-solid/LockAlt'
import { ownsNFTAtom, rControlsVisibilityAtom } from './atoms'
import { useAtom } from 'jotai'

/*======================== React component ===================================*/

const LockDisplay = (): JSX.Element => {
  const [ownsNFT] = useAtom(ownsNFTAtom)
  const [controlsVisible] = useAtom(rControlsVisibilityAtom)

  return (
    <Wrapper visible={!ownsNFT && !controlsVisible}>
      <PreviewText>{`PREVIEW`}</PreviewText>
      <LockIcon />
    </Wrapper>
  )
}

export default LockDisplay

/*======================== Styled components =================================*/

const Wrapper = styled.div<{ visible: boolean }>`
  pointer-events: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 300ms ease-out;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  gap: 5px;
`

const PreviewText = styled.div`
  pointer-events: none;
  font-size: 16px;
  font-weight: 400;
  color: white;

  @media (min-width: 43em) {
    font-size: 24px;
  }
`

const LockIcon = styled(LockAlt)`
  height: 18px;
  color: white;

  @media (min-width: 43em) {
    height: 26px;
  }
`
